export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-simple-rich-text/index.js